import { Component, Input, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-verification-gate',
  templateUrl: './verification-gate.component.html',
  styleUrls: ['./verification-gate.component.scss']
})
export class VerificationGateComponent {
  @Input() data: any;
  @Input() title: string = 'Identity Verification Required';
  @Input() description: string = 'You need to complete <strong>Aadhaar verification</strong> (or passport verification for international producers) to create and launch campaigns. This ensures secure transactions and compliance with advertising regulations.';
  @Input() navigateTo: string = '/studio-settings/account';
  @Input() icon: string = '!';

  constructor(
    private commonService: CommonService,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Optional() private dialogRef: MatDialogRef<VerificationGateComponent>
  ) { }

  ngOnInit(): void {
    if (this.dialogData) {
      if (!this.data) {
        this.data = this.dialogData;
      }
      this.title = this.dialogData.title || this.title;
      this.description = this.dialogData.description || this.description;
      this.navigateTo = this.dialogData.navigateTo || this.navigateTo;
      this.icon = this.dialogData.icon || this.icon;
    }
  }

  goToVerification() {
    this.close();
    this.router.navigate([this.navigateTo]);
  }

  close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.commonService.closePopUp();
    }
  }
}
